import BASE_URL from "./URLs"

const api = {}

var stationNumber = ""

api.fbSetStationNumber = (stationNum) => {
  stationNumber = stationNum
}

api.reportFBEventUrl = BASE_URL + `/api/logs`

api.reportFBEventBody = (
  eventName,
  eventMsg,
  TimeStamp = new Date(),
  StationNumber = stationNumber
) => {
  return { eventName, eventMsg, TimeStamp, StationNumber }
}

export default api
